import { render, staticRenderFns } from "./RegisteredByToken.vue?vue&type=template&id=79bd76fe&scoped=true"
import script from "./RegisteredByToken.vue?vue&type=script&lang=ts"
export * from "./RegisteredByToken.vue?vue&type=script&lang=ts"
import style0 from "./RegisteredByToken.vue?vue&type=style&index=0&id=79bd76fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@corefy+vue2-vue-template-compiler@2.7.24_css-loader@6.8.1_webpack@5_b8049d8d702ee6dc36dae9749dee35d1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bd76fe",
  null
  
)

export default component.exports